import { GetIrrigationsResponse } from '../../../requests/api/apiTypes';
import { DashboardData, Irrigation } from './riego.types';
import { SCHEDULED_STATUSES } from './riego.constants';

const mapDashboardData = (response: GetIrrigationsResponse): DashboardData => {
  const farmId = response.farmId || '';

  const irrigations: Irrigation[] = response.irrigations
    .filter((item) => item.zoneId != null)
    .map((item) => ({
      id: item.id,
      initTime: item.initTime,
      endTime: item.endTime,
      status: item.status,
      rawStatus: item.rawStatus ?? undefined,
      irrigationType: item.irrigationType ?? undefined,
      zoneId: item.zoneId as number,
      pumpSystemId: item.pumpSystemId ?? undefined,
      volume: item.volume
        ? { value: item.volume.value ?? undefined, unit: item.volume.unit ?? undefined }
        : undefined,
      precipitation: item.precipitation
        ? {
          value: item.precipitation.value ?? undefined,
          unit: item.precipitation.unit ?? undefined,
        }
        : undefined,
    }));

  return {
    farmId,
    pumpSystems: response.pumpSystems.map((pump) => ({
      id: pump.id,
      name: pump.name,
      farmId,
    })),
    zones: response.zones.map((zone) => ({
      id: zone.id,
      name: zone.name,
      farmId,
      pumpSystemId: zone.pumpSystemId ?? undefined,
    })),
    scheduledIrrigations: irrigations.filter((item) => SCHEDULED_STATUSES.has(item.status)),
    realIrrigations: irrigations.filter((item) => !SCHEDULED_STATUSES.has(item.status)),
  };
};

export default mapDashboardData;
